module.exports = __webpack_public_path__ + "javascripts/components/Podcast/SubscriptionOption/pocket_casts-6c5665926c049c51794dbfba99686623.svg";